module.exports = __webpack_public_path__ + "img/_weapon_potion_04.be6257a4.png";